import axios from "@/libs/api.request";


//后台管理配置查询
export const queryAdminConfig = data => {
	return axios.request({
		url: "/api/v1/settings/queryAdminConfig",
		params: data,
		method: "get"
	});
};

// 查询配送单配置
export const queryDeliverySetting = data => {
	return axios.request({
		url: "/api/v1/settings/queryDeliverySetting",
		params: data,
		method: "get"
	});
};

// 保存分拣设置
export const saveSortingSetting = data => {
	return axios.request({
		url: "/api/v1/settings/saveSortingSetting",
		data,
		method: "post"
	});
};

// 查询运营时间
export const queryOperationList = data => {
	return axios.request({
		url: "/api/v1/settings/queryOperationList",
		params: data,
		method: "get"
	});
};



// WEBPACK FOOTER //
// ./src/api/system/settings.js